import _ from 'lodash'

const cloneObject = (data) => {
    // Date.prototype.toJSON = function(){
    //     return {
    //         exportedType: 'date',
    //         value: this.toString()
    //     }
    // }

    let newObject = JSON.parse(JSON.stringify(data))

    for(let property in newObject) {
        if(typeof(newObject[property]) === 'object' && newObject[property]) {
            if(newObject[property].exportedType === 'date') {
                newObject[property] = new Date(newObject[property].value)
            }
        }
    }

    return newObject
}

const countObject = (object) => {
    let count = 0

    for (var k in object) {
        if (object.hasOwnProperty(k)) {
           ++count
        }
    }

    return count
}

const filterObject = (object, method) => {
    let result = {},
        key

    for (key in object) {
        if (object.hasOwnProperty(key) && method(object[key])) {
            result[key] = object[key]
        }
    }

    return result
}

const isEmpty = (object) => {
    if(! object) {
        return true
    }

    return Object.keys(object).length == 0
}

const isObject = (object) => {
    return typeof object === 'object'
}

const joinObject = (object) => {
    return Object.keys(object).map(key => `${key}=${object[key]}`).join("&")
}

const objectsDiff = (fromObject, toObject) => {
    const changes = {};

    const buildPath = (path, obj, key) =>
        _.isUndefined(path) ? key : `${path}.${key}`;

    const walk = (fromObject, toObject, path) => {
        for (const key of _.keys(fromObject)) {
            const currentPath = buildPath(path, fromObject, key);
            if (!_.has(toObject, key)) {
                changes[currentPath] = {from: _.get(fromObject, key)};
            }
        }

        for (const [key, to] of _.entries(toObject)) {
            const currentPath = buildPath(path, toObject, key);
            if (!_.has(fromObject, key)) {
                changes[currentPath] = {to};
            } else {
                const from = _.get(fromObject, key);
                if (!_.isEqual(from, to)) {
                    if (_.isObjectLike(to) && _.isObjectLike(from)) {
                        walk(from, to, currentPath);
                    } else {
                        changes[currentPath] = {from, to};
                    }
                }
            }
        }
    };

    walk(fromObject, toObject);

    return changes;
}

const serialize = (obj, prefix) => {
    let str = [], p

    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            let k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];

            str.push((v !== null && typeof v === "object")
                        ? serialize(v, k)
                        : encodeURIComponent(k) + "=" + encodeURIComponent(v)
                    )
        }
    }

    return str.join("&");
}

const sliceObject = (object, from, to) => {
    return Object.keys(object).slice(from, to).reduce((result, key) => {
        result[key] = object[key]

        return result
    }, {})
}

const sortByKey = (object) => {
    return Object
            .keys(object)
            .sort()
            .reduce((obj, key) => { 
                obj[key] = object[key]

                return obj
            },
            {})
}

export {
    cloneObject,
    countObject,
    filterObject,
    isEmpty,
    isObject,
    joinObject,
    objectsDiff,
    serialize,
    sliceObject,
    sortByKey,
}
